<template>
    <div class="card-body py-5 text-center">
        <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    mounted() {
        localStorage.removeItem('gsprima_token');
        axios.defaults.headers.common['Authorization'] = '';
        window.location.reload();
    }
}
</script>